import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
const ProductTileGrid = ({ children, }) => {
    return _jsx("div", { className: styles.product_tile_grid, children: children });
};
export default ProductTileGrid;
